// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"33af94ff707ae5ecde7f","678":"80b0ea30339b94ed358b","883":"466f19515211d391e818"}[chunkId] + ".js";
};